import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/index.styles'
import useElementVisible from '../app/hooks/useElementVisible'
import VisibilitySensor from '../VisibilitySensor'
import { ProcessoPageConfig } from '../configuration'
import { CharacterReveal } from 'react-text-reveal'
import SlideUpHOC from '../SlideUpHOC'
import Vimeo from "@u-wave/react-vimeo";
import OnViewPortEnter from '../OnViewPortObserver'
import AssignId from '../AssignId'

const useStyles = makeStyles(styles)

function Processo() {
    const showTitle = false;
    const [state, animateText] = useElementVisible({
        h1: false,
        p: false
    })
    const classes = useStyles()
    return (
        <div className={classes.root} >
            <AssignId
                absolute
                id='processo'
                y='-120px'
                yMobile='-70px'
            />
            <OnViewPortEnter
                absolute
                y={ProcessoPageConfig.primaryTextOffset}
                yMobile={ProcessoPageConfig.primaryTextOffsetMobile}
                onEnterViewPort={() => animateText('h1')}
            />
            <CharacterReveal
                animateOpacity={false}
                canPlay={state.h1}
                className={classes.h1}
                characterOffsetDelay={0}
                copy={ProcessoPageConfig.content.primary}
                direction={"bottom"}
                duration={800}
                ease={"cubic-bezier(0,0.4,0.4,1)"}
                offset={"150px"}
                multilineMasking={true}
                multilineOffsetDelay={0}
            />
            <OnViewPortEnter
                absolute
                y={ProcessoPageConfig.subTextOffset}
                yMobile={ProcessoPageConfig.subTextOffsetMobile}
                onEnterViewPort={() => animateText('p')}
            />
            <VisibilitySensor index={2} />
            <SlideUpHOC duration='0.8s' when={state.p} >
                <p className={classes.p} >
                    {ProcessoPageConfig.content.secondary[0]}
                    <strong className="strong">{ProcessoPageConfig.content.secondary[1]}</strong>
                    {ProcessoPageConfig.content.secondary[2]}
                    <strong className="strong">{ProcessoPageConfig.content.secondary[3]}</strong>
                    {ProcessoPageConfig.content.secondary[4]}
                    <strong className="strong">{ProcessoPageConfig.content.secondary[5]}</strong>
                </p>
            </SlideUpHOC>
            <div className={classes.shrinkIframe} >
                <div className={classes.iframeWrap} >
                    <Vimeo
                        className={classes.iframe}
                        video={ProcessoPageConfig.video.id}
                        responsive
                        paused        
                        color='FFC636'
                        showTitle={showTitle}
                        showByline={showTitle}
                        showPortrait={showTitle}
                    />
                </div>
            </div>
        </div>
    )
}

export default memo(Processo)